import {ChipProps } from "@heroui/chip";
import { DBSchema } from 'idb';
import  axios  from "axios";
import { siteConfig } from "@/config/site";
import { getCookie } from "typescript-cookie";

export type UserModel = {
    id         : string;
    name       : string;
    surname    : string;
    email      : string;
    phone      : string;
    picture    : string;
    password   : string;

    street     : string;
    city       : string;
    post       : string;
    country    : string;

    active     : boolean;

    created    : string;

    role       : number
};

export const Role : Record<number, String> = {
  0: "Personal",
  1: "Admin",
  2: "Customer",
};

export const colorRole: Record<number, ChipProps["color"]> = {
  0: "default",
  1: "warning",
  2: "success",
};

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  limit: number;
  offset: number;
}

export class Users {

  Users: UserModel[]  = [] as UserModel[];

  async Load() {

    var Token =  undefined

    try{ Token = getCookie('sessionKey'); }catch{}

    if(!Token) { return }

    let offset = 0;
    const limit = 50;

    const json: PaginatedResponse<UserModel> = (await axios.get(siteConfig.Backend_URL + 'user/admin_users?limit='+limit+'&offset='+offset, { headers: { "Authorization" : `Bearer ${Token}`}})).data;

    this.Users = json.data
    
    return json.data
  }
}

export interface UserDB extends DBSchema {
  users: {
    value: UserModel;
    key: string;
    indexes: { 'by-id': string };
  };
}
